// 🏗️ FSD Shared Layer - Pricing Styled Components
// PricingPage에서 사용되는 모든 styled-components 정의
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  min-height: 100vh;\n  background: ",
        ";\n  color: var(--theme-text);\n  transition: background var(--theme-transition-normal), color var(--theme-transition-normal);\n\n  @media (min-width: ",
        ") {\n    padding: 2rem;\n  }\n\n  @keyframes pulse {\n    0%, 100% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 1200px;\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: ",
        ";\n  backdrop-filter: blur(10px);\n  border: 1px solid ",
        ";\n  box-shadow: ",
        ";\n  margin-bottom: 1.5rem;\n  border-radius: 16px;\n  transition: all var(--theme-transition-normal);\n\n  @media (min-width: ",
        ") {\n    padding: 1rem 2rem;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.3rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  cursor: pointer;\n  @media (min-width: ",
        ") {\n    font-size: 1.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 2.5rem;\n  background: ",
        ";\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1rem;\n  text-align: center;\n  padding: 0 1rem;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n\n  @media (min-width: ",
        ") {\n    font-size: 3.5rem;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.1rem;\n  color: var(--theme-text-secondary);\n  margin-bottom: 3rem;\n  text-align: center;\n  padding: 0 1rem;\n  max-width: 600px;\n  line-height: 1.7;\n  font-weight: 500;\n\n  @media (min-width: ",
        ") {\n    font-size: 1.3rem;\n    margin-bottom: 4rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr; // 모바일에서는 기본 1열\n  gap: 1.5rem; // 모바일 갭\n  width: 100%;\n  max-width: 500px; // 모바일에서 최대 너비 제한 (너무 넓어지지 않게)\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); // 태블릿부터 기존 그리드 유지\n    gap: 2rem;\n    max-width: 1200px; // 태블릿 이상에서 최대 너비 확장\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 2px solid ",
        ";\n  transition: all var(--theme-transition-normal);\n  position: relative;\n  cursor: pointer;\n\n  &:hover {\n    border-color: var(--theme-primary);\n    box-shadow: ",
        ";\n    transform: translateY(-4px);\n  }\n\n  &.recommended {\n    border-color: var(--theme-warning, #f97316);\n    background: ",
        ";\n    box-shadow: ",
        ';\n    \n    &::before {\n      content: "가장 인기";\n      position: absolute;\n      top: -12px;\n      left: 50%;\n      transform: translateX(-50%);\n      background: linear-gradient(135deg, var(--theme-warning, #f97316) 0%, #ea580c 100%);\n      color: #fff;\n      padding: 6px 20px;\n      border-radius: 20px;\n      font-size: 0.75rem;\n      font-weight: 700;\n      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n      letter-spacing: 0.02em;\n      border: none;\n    }\n  }\n\n  &.free {\n    border-color: var(--theme-success);\n    background: ',
        ";\n  }\n\n  &.business {\n    border-color: ",
        ";\n    background: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 2rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n    color: var(--theme-primary);\n    margin-bottom: 1rem;\n    font-weight: 600;\n    @media (min-width: ",
        ") {\n      font-size: 1.8rem;\n      margin-bottom: 1rem;\n    }\n  }\n\n  p.price {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: var(--theme-text);\n    margin-bottom: 0.5rem;\n    background: ",
        ";\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    \n    @media (min-width: ",
        ") {\n      font-size: 3rem;\n      margin-bottom: 0.5rem;\n    }\n  }\n\n  p.billing-cycle {\n    font-size: 0.9rem;\n    color: var(--theme-text-secondary);\n    margin-bottom: 1.5rem;\n    font-weight: 500;\n    @media (min-width: ",
        ") {\n      font-size: 1rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 2rem;\n    text-align: left;\n    @media (min-width: ",
        ") {\n      margin-bottom: 2.5rem;\n    }\n    li {\n      font-size: 0.95rem;\n      margin-bottom: 0.75rem;\n      color: var(--theme-text);\n      line-height: 1.5;\n      @media (min-width: ",
        ") {\n        font-size: 1rem;\n        margin-bottom: 1rem;\n      }\n      &::before {\n        content: '✓';\n        color: var(--theme-success);\n        margin-right: 0.75rem;\n        font-weight: bold;\n        font-size: 1.1em;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { breakpoints } from '@edusense/shared-pricing-constants';
/**
 * 메인 페이지 컨테이너
 */ export var PageContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.background, " 0%, ").concat(theme.paperDark, " 30%, ").concat(theme.backgroundDark, " 100%)") : 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 30%, #f0f9ff 100%)';
}, breakpoints.tablet);
/**
 * 페이지 헤더
 */ export var Header = styled.header(_templateObject1(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "".concat(theme.paperDark, "cc") : 'rgba(255, 255, 255, 0.9)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "".concat(theme.borderLight, "40") : 'rgba(255, 255, 255, 0.2)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? '0 8px 32px rgba(0, 0, 0, 0.3)' : '0 8px 32px rgba(0, 0, 0, 0.1)';
}, breakpoints.tablet);
/**
 * 로고 컴포넌트
 */ export var Logo = styled.h1(_templateObject2(), breakpoints.tablet);
/**
 * 메인 타이틀
 */ export var Title = styled.h1(_templateObject3(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.text, " 0%, ").concat(theme.textSecondary, " 50%, ").concat(theme.textMuted, " 100%)") : 'linear-gradient(135deg, #1f2937 0%, #4b5563 50%, #6b7280 100%)';
}, breakpoints.tablet);
/**
 * 서브타이틀
 */ export var Subtitle = styled.p(_templateObject4(), breakpoints.tablet);
/**
 * 플랜 그리드 레이아웃
 */ export var PlanGrid = styled.div(_templateObject5(), breakpoints.tablet);
/**
 * 개별 플랜 카드
 */ export var PlanCard = styled.div(_templateObject6(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.paper, " 0%, ").concat(theme.paperDark, " 100%)") : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.border : '#e5e7eb';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3)' : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, rgba(255, 158, 10, 0.18) 0%, rgba(253, 186, 116, 0.28) 100%)" : 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? '0 20px 25px -5px rgba(245, 158, 11, 0.3)' : '0 20px 25px -5px rgba(245, 158, 11, 0.15)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.paperLight, "20 0%, ").concat(theme.paperLight, "40 100%)") : 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.textSecondary : '#6b7280';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.paperDark, " 0%, ").concat(theme.backgroundDark, " 100%)") : 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)';
}, breakpoints.tablet, breakpoints.tablet, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? "linear-gradient(135deg, ".concat(theme.text, " 0%, ").concat(theme.textSecondary, " 100%)") : 'linear-gradient(135deg, #1f2937 0%, #4b5563 100%)';
}, breakpoints.tablet, breakpoints.tablet, breakpoints.tablet, breakpoints.tablet);
